import { render, staticRenderFns } from "./WechatUserinfoList.vue?vue&type=template&id=383d37a4&scoped=true"
import script from "./WechatUserinfoList.vue?vue&type=script&lang=ts"
export * from "./WechatUserinfoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d37a4",
  null
  
)

export default component.exports